<div class="smart-charge-deadline">
  <p>Smartlading ferdig til</p>
  <ion-button
    class="time"
    (click)="toggleTimepicker()"
    [disabled]="isOverridden"
  >
    <ion-icon name="time-outline"></ion-icon>
    <p>
      <strong>{{ selectedTime }}</strong>
    </p>
  </ion-button>
</div>

<div
  class="timepicker-container"
  [class.setup]="duringSetup"
  *ngIf="displayTimepicker"
>
  <div class="timepicker">
    <div class="suggestions-container">
      <p>Forslag til tidspunktt</p>
      <div class="suggestions">
        <ion-button
          *ngFor="let time of timeSuggestions"
          class="suggestion"
          (click)="useSuggestion(time)"
        >
          <p>
            {{ time.name }}
          </p>
        </ion-button>
      </div>
    </div>
    <div>
      <ion-datetime
        presentation="time"
        mode="ios"
        (ionChange)="selectTime($event)"
        [(ngModel)]="selectedTime"
        [disabled]="isOverridden"
      ></ion-datetime>
    </div>
  </div>
  <div class="button-container">
    <ion-button class="cancel-button" (click)="toggleTimepicker()">
      Avbryt
    </ion-button>
    <ion-button class="dark" (click)="emitTime()"> Lagre </ion-button>
  </div>
</div>
